import gql from 'graphql-tag'

const refreshTokenAccurate = gql`
  mutation refreshTokenAccurate($db_id: Float!, $workspace_id: Float!) {
    refreshTokenAccurate(db_id: $db_id, workspace_id: $workspace_id) {
      status
      msg
      data
    }
  }
`

export default refreshTokenAccurate
